import React from "react";

import {
  // CheckCircleOutlined,
  InfoCircleOutlined,
  // TagFilled,
} from "@ant-design/icons";
import { Spin } from "antd";

import StatusLabelTag from "../../components/StatusLabelTag";

import { formatCurrency } from "../../utils";

import { ReactComponent as FlowersIllustration } from "../../../../../assets/images/subscriptions/Flowers.svg";

function SummaryMetricRow({
  label,
  detail,
  value,
  valueClassName = "",
  labelClassName = "",
}) {
  return (
    <div className={`ReviewTopUpPaymentSummary__Metric ${labelClassName}`.trim()}>
      <div className="ReviewTopUpPaymentSummary__MetricCopy">
        <p className="ReviewTopUpPaymentSummary__MetricLabel">{label}</p>
        {detail && (
          <p className="ReviewTopUpPaymentSummary__MetricDetail">{detail}</p>
        )}
      </div>
      <p className={`ReviewTopUpPaymentSummary__MetricValue ${valueClassName}`.trim()}>
        {value}
      </p>
    </div>
  );
}

function OneTimePaymentSummary({ displayCredits, displayAmount }) {
  return (
    <div className="ReviewTopUpPaymentSummary__Metrics">
      <SummaryMetricRow
        label="Total Test Credits"
        detail="Across all categories"
        value={Number(displayCredits).toLocaleString()}
        labelClassName="ReviewTopUpPaymentSummary__Metric--hero"
        valueClassName="ReviewTopUpPaymentSummary__MetricValue--hero"
      />
      <SummaryMetricRow
        label="Final Amount"
        detail="Total Amount Due (USD)"
        value={formatCurrency(displayAmount)}
        labelClassName="ReviewTopUpPaymentSummary__Metric--hero"
        valueClassName="ReviewTopUpPaymentSummary__MetricValue--hero ReviewTopUpPaymentSummary__MetricValue--amount"
      />
    </div>
  );
}

function SubscriptionPaymentSummary({
  currentMonthlyBill,
  addedMonthlyValue,
  addedTestsPerMonth,
  newMonthlyBill,
  currentMonthlyBillLoading = false,
}) {
  return (
    <div className="ReviewTopUpPaymentSummary__Metrics">
      <SummaryMetricRow
        label="Current month bill"
        detail="Across all categories"
        value={currentMonthlyBillLoading
          ? <Spin size="small" />
          : formatCurrency(currentMonthlyBill)}
        labelClassName="ReviewTopUpPaymentSummary__Metric--compact"
      />
      <SummaryMetricRow
        label="Added value"
        detail="Total Amount Added (USD)"
        value={`+${formatCurrency(addedMonthlyValue)}`}
        labelClassName="ReviewTopUpPaymentSummary__Metric--compact"
        valueClassName="ReviewTopUpPaymentSummary__MetricValue--amount-cool"
      />

      <div className="ReviewTopUpPaymentSummary__Divider" aria-hidden />

      <SummaryMetricRow
        label="Added credits"
        detail="Across all categories"
        value={Number(addedTestsPerMonth).toLocaleString()}
        labelClassName="ReviewTopUpPaymentSummary__Metric--hero"
        valueClassName="ReviewTopUpPaymentSummary__MetricValue--hero"
      />
      <SummaryMetricRow
        label="New current month bill"
        detail="Total Amount Due (USD)"
        value={formatCurrency(newMonthlyBill)}
        labelClassName="ReviewTopUpPaymentSummary__Metric--hero"
        valueClassName="ReviewTopUpPaymentSummary__MetricValue--hero ReviewTopUpPaymentSummary__MetricValue--amount"
      />
    </div>
  );
}

export default function ReviewTopUpPaymentSummary({
  variant = "topup",
  displayCredits = 0,
  displayAmount = 0,
  currentMonthlyBill = 0,
  currentMonthlyBillLoading = false,
  newMonthlyBill = 0,
  // savings = 0,
  // offersUnlocked = 0,
  summaryNote = "",
}) {
  const isSubscription = variant === "subscription";

  return (
    <aside className="ReviewTopUpPaymentSummary">
      <FlowersIllustration
        className="ReviewTopUpPaymentSummary__Flower ReviewTopUpPaymentSummary__Flower--topLeft"
        aria-hidden
      />
      <FlowersIllustration
        className="ReviewTopUpPaymentSummary__Flower ReviewTopUpPaymentSummary__Flower--bottom"
        aria-hidden
      />
      <div className="ReviewTopUpPaymentSummary__Gradient" aria-hidden />

      <div className="ReviewTopUpPaymentSummary__Content">
        <section className="ReviewTopUpPaymentSummary__Section">
          <h3 className="ReviewTopUpPaymentSummary__SectionTitle">Payment Summary</h3>

          {isSubscription ? (
            <SubscriptionPaymentSummary
              currentMonthlyBill={currentMonthlyBill}
              currentMonthlyBillLoading={currentMonthlyBillLoading}
              addedMonthlyValue={displayAmount}
              addedTestsPerMonth={displayCredits}
              newMonthlyBill={newMonthlyBill}
            />
          ) : (
            <OneTimePaymentSummary
              displayCredits={displayCredits}
              displayAmount={displayAmount}
            />
          )}
        </section>

        {/* <div className="ReviewTopUpPaymentSummary__Divider ReviewTopUpPaymentSummary__Divider--section" aria-hidden /> */}

        {/* <section className="ReviewTopUpPaymentSummary__Section ReviewTopUpPaymentSummary__Section--benefits">
          <h3 className="ReviewTopUpPaymentSummary__SectionTitle">Benefits</h3>

          <div className="ReviewTopUpPaymentSummary__Benefit">
            <div className="ReviewTopUpPaymentSummary__BenefitLeading">
              <span className="ReviewTopUpPaymentSummary__BenefitIcon ReviewTopUpPaymentSummary__BenefitIcon--savings">
                <CheckCircleOutlined aria-hidden />
              </span>
              <p className="ReviewTopUpPaymentSummary__BenefitLabel">Savings</p>
            </div>
            <p className="ReviewTopUpPaymentSummary__BenefitValue">
              {`${formatCurrency(savings)} USD`}
            </p>
          </div>

          <div className="ReviewTopUpPaymentSummary__Benefit">
            <div className="ReviewTopUpPaymentSummary__BenefitLeading">
              <span className="ReviewTopUpPaymentSummary__BenefitIcon ReviewTopUpPaymentSummary__BenefitIcon--offers">
                <TagFilled aria-hidden />
              </span>
              <p className="ReviewTopUpPaymentSummary__BenefitLabel">Offers Unlocked</p>
            </div>
            <p className="ReviewTopUpPaymentSummary__BenefitValue">{offersUnlocked}</p>
          </div>
        </section> */}
      </div>

      {summaryNote && (
        <StatusLabelTag
          tone="muted"
          icon={<InfoCircleOutlined />}
          wrap
          className="ReviewTopUpPaymentSummary__Note"
        >
          {summaryNote}
        </StatusLabelTag>
      )}
    </aside>
  );
}
